import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import $ from 'jquery';

import router from './router/simulator';
import store from './store';
import settings from './settings';
import ls from './services/ls';

import Simulator from './Simulator.vue';

import '@fortawesome/fontawesome-free/css/all.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.min.css';
import '../html/build-dev/css/main.min.css';

Vue.use(BootstrapVue);

// provide jQuery
window.jQuery = $;
window.$ = $;

ls.initAppSettings();

Vue.config.productionTip = false;
Vue.prototype.$APP_URL = settings.APP_URL;
Vue.prototype.$appSettings = JSON.parse(ls.get('pdd-settings'));

new Vue({
  router,
  store,
  render: h => h(Simulator),
}).$mount('#simulator');
